import { useState } from 'react';
import ScheduledJobsListTab from './ScheduledJobsListTab';
import ScheduledJobsRunLogsTab from './ScheduledJobsRunLogsTab';

interface Props {
    token: string;
}

type SubTab = 'jobs' | 'logs';

const TABS: { key: SubTab; label: string }[] = [
    { key: 'jobs', label: 'Jobs' },
    { key: 'logs', label: 'Run Logs' },
];

export default function ScheduledJobsTab({ token }: Props) {
    const [activeSubTab, setActiveSubTab] = useState<SubTab>('jobs');

    return (
        <div>
            <div className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900">Scheduled Jobs</h2>
                <p className="text-sm text-gray-500">System-maintenance jobs that run globally across all gyms.</p>
            </div>

            <div className="border-b border-gray-200 mb-6">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {TABS.map(t => (
                        <button
                            key={t.key}
                            onClick={() => setActiveSubTab(t.key)}
                            className={`${activeSubTab === t.key
                                ? 'border-indigo-500 text-indigo-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                        >
                            {t.label}
                        </button>
                    ))}
                </nav>
            </div>

            {activeSubTab === 'jobs' && <ScheduledJobsListTab token={token} />}
            {activeSubTab === 'logs' && <ScheduledJobsRunLogsTab token={token} />}
        </div>
    );
}
